import { render, staticRenderFns } from "./StickerForm.vue?vue&type=template&id=00db6d08&scoped=true&"
import script from "./StickerForm.vue?vue&type=script&lang=js&"
export * from "./StickerForm.vue?vue&type=script&lang=js&"
import style0 from "./StickerForm.vue?vue&type=style&index=0&id=00db6d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db6d08",
  null
  
)

export default component.exports